"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _services = require("../../../../services");
var _constants = require("../../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BusinessSolutionValueText = _styledComponents.default.span`
  font-weight: bold;
  margin-right: 5px;
`;
const BusinessSolutionCardInfo = _ref => {
  let {
    businessSolution,
    businessSolutionIndex
  } = _ref;
  const hideSpecIds = ['longDescription', 'businessSolutionUrl', 'description'];
  const groupPriority = {
    advantages: 1,
    features: 2,
    bulletFeatures: 3
  };
  const FEATURE_WITHOUT_NAME = 'bulletFeatures';
  const characteristics = (0, _lodash.default)(businessSolution.selectedVariant.characteristics, c => {
    var _c$value$;
    return (_c$value$ = c.value[0]) === null || _c$value$ === void 0 ? void 0 : _c$value$.value;
  }).filter(c => {
    return !hideSpecIds.includes(c.id);
  }).sort((a, b) => {
    const groupPriorityA = Math.min(...a.groups.map(group => groupPriority[group]));
    const groupPriorityB = Math.min(...b.groups.map(group => groupPriority[group]));
    return groupPriorityA - groupPriorityB;
  });
  const parseSpecValue = spec => {
    const specValues = spec.value.map(val => {
      return val.value >= _constants.UNLIMITED_VALUE ? _services.locale.localeString('Recommendation.BroadbandUnlimited') : val.value;
    });
    const isAllBooleans = specValues.every(val => typeof val === 'boolean');
    return isAllBooleans ? specValues.every(Boolean) : specValues.join(', ');
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    id: "business-solution-card-info"
  }, characteristics.map((spec, index) => {
    const valueText = parseSpecValue(spec);
    if (!valueText) return null;
    return /*#__PURE__*/_react.default.createElement("li", {
      "data-testid": "business-solution-card-info-item",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      spacing: 1,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `feature-${index}-name-tab-${businessSolutionIndex}`
      }
    }, !spec.groups.includes(FEATURE_WITHOUT_NAME) && /*#__PURE__*/_react.default.createElement(BusinessSolutionValueText, null, spec.name), valueText)), index < characteristics.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  })));
};
var _default = BusinessSolutionCardInfo;
exports.default = _default;